// extracted by mini-css-extract-plugin
export default {"heading":"employee_heading__vxVRf","box":"employee_box__s7WtS"};